import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'

import { UsersDashboard, UsersDetail } from '../../../features/users'
import { USERS_COMBOS_IDS } from '../constants'
import { useCombos } from '../../../features/combos/hooks'

export const UsersPage = () => {
  useCombos(USERS_COMBOS_IDS)

  return (
    <Routes>
      <Route exact path="" element={<UsersDashboard />} />
      <Route exact path=":userId" element={<UsersDetail />} />
      <Route path="*" element={<Navigate to="" replace />} />
    </Routes>
  )
}
